import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {AuthentificationService} from './authentification.service';
import {MdDialog, MdDialogRef} from '@angular/material';
import {DialogComponent} from './dialog.component';
import {AppComponent} from './app.component';
import {WharehousesService} from './warehouses.service';
import {LeftMenuComponent} from './left-menu.component';

@Component({
    selector: 'super_users',
    styleUrls: ['./styles/users.component.css'],
    templateUrl: './templates/super_users.component.html',
    providers: [AuthentificationService, WharehousesService, LeftMenuComponent]
})


export class SuperUsersComponent {
    name = 'SuperUsers';

    warehouse_list: Array<Object>;
    selectedOption: string;
    notvalid_input: boolean = true;
    wharehouse_name: string = "";
    name_search: string = "";

    IsValidInput(): void {
        if (this.wharehouse_name !== "") {
            this.notvalid_input = false;
        } else {
            this.notvalid_input = true;
        }
    }
    /*openDialog() {
        this.dialog.open(DialogComponent);
    }*/
    /*openDialog() {
        this.dialog.open(DialogExampleComponent);
    }*/
    ValidateButton(): void {
        this.CreateWharehouse();
    }

    constructor(public dialog: MdDialog, private authentification_service: AuthentificationService, private router: Router, private app_component: AppComponent, private left_menu_component: LeftMenuComponent, private warehouse_service: WharehousesService) {

        this.CheckUSerSession();

        //this.app_component.sudo_left_menu = true;
    }

    CheckUSerSession(): void {
        this.authentification_service.SuperUserCheckSession().then(result => {
            if (result['id_super_user'] === 0) {
                this.router.navigate(['admin'])
            } else {
                this.app_component.ShowMenu();
                this.app_component.sudo_left_menu = true;

                //this.authentificate = true;
                //this.router.navigate(['admin/warehouse']);
            }
        });
    }

    CreateWharehouse(): void {
        this.warehouse_service.CreateWharehouse(this.wharehouse_name).then(result => {this.warehouse_list = result['warehouses_list']; this.wharehouse_name = ""; this.IsValidInput();});
    }

    GetWarehouses(): void {
        this.warehouse_service.GetWarehouses().then(result => {this.warehouse_list = result['list']});
    }

    ModifyCatergory(warehouse: any): void {

    }

    DialogConfirm(warehouse: any): void {


    }

    ModifyWarehouse(): void {

    }

    DeleteWarehouse(warehouse: any): void {

    }

    LogOut(): void {
        this.authentification_service.superLogOut().then(result => {console.log(result)});
    }

    WarehouseSearch(): void {
        this.warehouse_service.WarehousesSearch(this.name_search).then(result => {this.warehouse_list = result['list']});
    }

    ngOnInit(): void {
        //this.GetWarehouses();
        this.app_component.HideMenu();
        this.WarehouseSearch();
    }

}


/*@Component({
  selector: 'dialog-result-example-dialog',
  templateUrl: 'dialog-result-example-dialog.html',
})
export class DialogResultExampleDialog {
  constructor(public dialogRef: MdDialogRef<DialogResultExampleDialog>) {}
}
*/




// WEBPACK FOOTER //
// ./src/app/super_users.component.ts